import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/layout/Layout';

// Page components
import HomePage from './pages/HomePage';
import FreelanceProfile from './pages/FreelanceProfile';
import ContactPage from './pages/ContactPage';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ThankYouPage from './pages/ThankYou';

// UI components
import ScrollToTop from './components/ui/ScrollToTop';

/**
 * The routed page tree. Shared by the browser app below and by
 * scripts/prerender.mjs, which renders it to static HTML at build time so
 * crawlers that don't run JavaScript still get the full page.
 */
export function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/freelance" element={<FreelanceProfile />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppRoutes />
        <ScrollToTop />
      </Router>
    </ThemeProvider>
  );
}

export default App;
